import React from 'react'
import './photosecfour.scss'
import { sec2 } from '../../data/PhotoData';
import SocialMediaPhoto from '../../component/SocialMediaPhoto';

function PhotSecFour() {
  return (
    <div className='p-sec-4-cont'>
      <div className='p-sec-4-inn'>
        <h2>{sec2.heading3}</h2>
        <h3>{sec2.des5}</h3>
        <div>
             <SocialMediaPhoto/>
        </div>
      </div>
    </div>
  )
}

export default PhotSecFour;